module.exports = __webpack_public_path__ + "img/partner10.566cbb14.png";